<div class="nav-container">
    <nav class="navbar">
        <div class="burger2">
            <img src="../../assets/img/kebab.png" style="width: 20px; height: 20px; margin-bottom: 6px;">
        </div>
        <div class="nav-hard-left">
            <input type="search" name="search" [(ngModel)]="searchInput" (keydown.enter)="search()">
        </div>
        <div id="mid-sec">
            <div class="nav-left">
                <ul>
                    <li><a class="nav-link" href="/categories/1">Bridal</a></li>
                    <li><a class="nav-link" href="/categories/4">Groom</a></li>
                </ul>
            </div>
            <div class="brand"><a href="/">Zebaish</a></div>
            <div class="nav-right">
                <ul>
                    <li><a class="nav-link" href="/categories/2">Casual</a></li>
                    <li><a class="nav-link" href="/categories/3">Suits</a></li>
                </ul>
            </div>
        </div>
        <div class="nav-hard-right">
            <ul *ngIf="!isAuthenticated">
                <li><a class="nav-link" href="/login">Log In</a></li>
                <li><a class="nav-link" href="/signup">Sign Up</a></li>
            </ul>
            <ul *ngIf="isAuthenticated">
                <li >
                    <a class="nav-link" href="#"><i class="fas fa-user-circle fa-2x profile"><div class="dropdown-content">
                        <p><a href="/profile">Profile</a></p>
                        <p (click)="logout()">Logout</p>
                        </div></i></a>
                    
                </li>
                <li><a class="nav-link" href="/cart"><i class="fas fa-shopping-cart fa-2x"></i><span class="badge">{{cartCounter}}</span></a></li>
            </ul>
        </div>
        <div class="burger" (click)="openNav()">
            <img src="../../assets/img/burger.svg" style="width: 20px; height: 20px; margin-bottom: 6px;">
        </div>
    </nav>
</div>
<nav class="mobile-nav {{activate}}">
    <div class="burger" (click)="closeNav()">
        <img src="../../assets/img/close-button.svg" style="width: 20px; height: 20px; margin-bottom: 6px;">
    </div>
    <input type="search" name="search" [(ngModel)]="searchInput" (keydown.enter)="search()" style="margin-left: 1em;">
    <ul>
        <li><a class="nav-link" href="/">Home</a></li>
        <li><a class="nav-link" href="/categories/2">Casual</a></li>
        <li><a class="nav-link" href="/categories/3">Suits</a></li>
        <li><a class="nav-link" href="/categories/4">Groom</a></li>
        <li><a class="nav-link" href="/categories/1">Bridal</a></li>
    </ul>
    <div >
        <ul *ngIf="!isAuthenticated">
            <li><a class="nav-link" href="/login">Log In</a></li>
            <li><a class="nav-link" href="/signup">Sign Up</a></li>
        </ul>
        <ul *ngIf="isAuthenticated">
            <li><a href="/profile">Profile</a></li>
            <li><a (click)="logout()">Logout</a></li>
            <li><a class="nav-link" href="/cart">Cart<span>({{cartCounter}})</span></a></li>
        </ul>
    </div>
</nav>